<template>
  <div class="animated fadeIn">
    Hello World
  </div>
</template>

<script>
export default
{
    name: 'dashboard',
};
</script>
